module.exports = __webpack_public_path__ + "static/media/continue_registration.76f93552.png";